import UserAvatar from '@/components/UserAvatar';
import { useUserManager } from '@/libs/hooks/useUserManager';
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { FormattedMessage, history, useModel } from '@umijs/max';
import { Menu, Spin } from 'antd';
import classNames from 'classnames';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React from 'react';
import HeaderDropdown from '../HeaderDropdown';
import { introductionsTarget } from '../Introduction';
import styles from './index.less';

const AvatarDropdown: React.FC = () => {
  const { profile } = useModel('user');
  const userManager = useUserManager();

  const onMenuClick = async (event: MenuInfo) => {
    const { key } = event;
    if (key === 'logout') {
      await userManager.signoutRedirect();
      return;
    }
    history.push(`/account?tab=${key}`);
  };

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!profile) {
    return loading;
  }

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      <Menu.Item key="profile">
        <UserOutlined />
        <FormattedMessage
          id="components.rightContent.userMenu.profile"
          defaultMessage="Hồ sơ cá nhân"
        />
      </Menu.Item>
      <Menu.Item key="password">
        <SettingOutlined />
        <FormattedMessage
          id="components.rightContent.userMenu.changePassword"
          defaultMessage="Đổi mật khẩu"
        />
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout">
        <LogoutOutlined />
        <FormattedMessage
          id="components.rightContent.userMenu.logout"
          defaultMessage="Đăng xuất"
        />
      </Menu.Item>
    </Menu>
  );

  return (
    <HeaderDropdown
      dropdownRender={() => menuHeaderDropdown}
      trigger={['click']}
    >
      <span
        className={classNames(
          introductionsTarget.dashboard.profileButton.substr(1),
          styles.action,
          styles.account,
        )}
      >
        <UserAvatar
          size="small"
          className={styles.avatar}
          url={profile.avatar}
          firstName={profile.name?.split(' ')?.[0]}
          lastName={profile.name?.split(' ')?.[1]}
        />
        <span className={`${styles.name} anticon`}>
          {profile.name?.split(' ')?.[0]}
        </span>
      </span>
    </HeaderDropdown>
  );
};

export default AvatarDropdown;
